import { useEffect, useRef } from 'react';

type ScriptAttr = {
  name: string;
  value: string;
};

const useScript = (
  url: string,
  type?: string,
  onError?: (event: ErrorEvent) => void,
  attrs: ScriptAttr[] = []
) => {
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    if (type) {
      script.type = type;
    }
    for (const { name, value } of attrs) {
      script.setAttribute(name, value);
    }
    script.onerror = (event) => onErrorRef.current?.(event as ErrorEvent);
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
    // type and attrs are intentionally omitted — changing them should not reload the script
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
};

export default useScript;
